import { VendorRebateCategories } from '../../../components/Vendor';

export function RebateCategories() {
  return <VendorRebateCategories />;
}
